import { graphql, useStaticQuery } from "gatsby";
import { ImageDataLike } from "gatsby-plugin-image";
import { Languages } from "@/src/types";

export type Props = {
  allWpProduct: {
    nodes: {
      url: string;
      title: string;
      slug: string;
      published_at: string;
      description: string;
      image_url: string;
      image: {
        childImageSharp: {
          gatsbyImageData: ImageDataLike;
        };
      };
      contentType: {
        node: {
          graphqlSingleName: string;
        };
      };
    }[];
  };
};

export const usePostsData = (lang: Languages) => {

  const data = useStaticQuery(graphql`
    query {
      sv: allWpProdukt (limit: 20, filter: { id: { ne: "dummy" }, language: {code: {eq: SV}}}) {
          nodes {
            uri
            date
            excerpt
            title
            featuredImage {
                node {
                altText
                sourceUrl
                title
                gatsbyImage(
                    placeholder: BLURRED
                    width: 2000
                    formats: AUTO
                    layout: FULL_WIDTH
                )
                }
            }
            contentType {
              node {
                graphqlSingleName
              }
            }
          }
        },
      en: allWpProdukt (limit: 20, filter: { id: { ne: "dummy" }, language: {code: {eq: EN}}}) {
          nodes {
            uri
            date
            excerpt
            title
            featuredImage {
                node {
                altText
                sourceUrl
                title
                gatsbyImage(
                    placeholder: BLURRED
                    width: 2000
                    formats: AUTO
                    layout: FULL_WIDTH
                )
                }
            }
            contentType {
              node {
                graphqlSingleName
              }
            }
          }
        },
        zh: allWpProdukt (limit: 20, filter: { id: { ne: "dummy" }, language: {code: {eq: ZH}}}) {
          nodes {
            uri
            date
            excerpt
            title
            featuredImage {
                node {
                altText
                sourceUrl
                title
                gatsbyImage(
                    placeholder: BLURRED
                    width: 2000
                    formats: AUTO
                    layout: FULL_WIDTH
                )
                }
            }
            contentType {
              node {
                graphqlSingleName
              }
            }
          }
        }
  }`);


  return data[lang].nodes;
};
